import { useMutation } from "@apollo/client/react";

import { DELETE_MANAGED_USER_GROUP } from "./gql";

const useDeleteGroup = (refetchQueries: string[]) => {
  const [deleteManagedUserGroup, { loading }] = useMutation(DELETE_MANAGED_USER_GROUP, {
    refetchQueries,
  });

  const onDelete = (id: string) => {
    return deleteManagedUserGroup({
      variables: {
        id,
      },
    });
  };

  return { onDelete, loading };
};

export default useDeleteGroup;
